
import { Vue } from "vue-class-component";

export default class Refresh extends Vue {}
